import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import routes from '../../common/models/route-constants';
import NotFoundPage from '../../common/pages/NotFoundPage';
import AnimatedIconHomePage from '../pages/AnimatedIconHomePage';
import CreateAnimatedIconPage from '../pages/CreateAnimatedIconPage';
import UpdateAnimatedIconPage from '../pages/UpdateAnimatedIconPage';

function AnimatedAssetsIconsRouter() {
  let { path } = useRouteMatch();
  return (
    <React.Fragment>
      <Switch>
        <Route exact path={`${path}`}>
          <AnimatedIconHomePage />
        </Route>
        <Route exact path={`${path}/${routes.CREATE}`}>
          <CreateAnimatedIconPage />
        </Route>
        <Route exact path={`${path}/:id`}>
          <UpdateAnimatedIconPage />
        </Route>
        <Route path='*'>
          <NotFoundPage />
        </Route>
      </Switch>
    </React.Fragment>
  );
}

export default AnimatedAssetsIconsRouter;
